import { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { Lock, ArrowLeft } from "lucide-react";

export default function ArticleDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [a, setA] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get(`/articles/${id}`).then((r) => setA(r.data)).catch(() => setA(null)).finally(() => setLoading(false));
  }, [id]);

  if (loading) return <div className="pt-40 text-center" style={{ color: "var(--ink-muted)" }}>Loading…</div>;
  if (!a) return <div className="pt-40 text-center" style={{ color: "var(--ink-muted)" }}>Article not found.</div>;

  return (
    <div data-testid="article-detail" className="pt-24">
      <article className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-8">
        <button onClick={() => navigate(-1)} className="text-xs uppercase tracking-[0.22em] mb-6 flex items-center gap-2 hover:text-[var(--brass)] transition-colors" style={{ color: "var(--ink-muted)" }}>
          <ArrowLeft size={14} /> Back
        </button>

        {/* Cover */}
        <div className="relative aspect-[21/9] overflow-hidden mb-12" style={{ background: "var(--surface)" }}>
          <img src={a.cover_image} alt={a.title} className="w-full h-full object-cover" />
        </div>

        {/* Title block */}
        <div className="max-w-3xl mx-auto mb-12 text-center">
          <p className="eyebrow mb-5">{a.category} · {a.author}</p>
          <h1 className="font-display text-5xl md:text-7xl mb-6 leading-[0.95]">{a.title}</h1>
          {a.subtitle && (
            <p className="text-xl italic" style={{ color: "var(--ink-muted)", fontFamily: "Cormorant Garamond" }}>
              {a.subtitle}
            </p>
          )}
        </div>

        <hr className="hairline max-w-3xl mx-auto mb-12" />

        {/* Body */}
        <div className="max-w-3xl mx-auto">
          <p className="text-lg leading-[1.85] drop-cap whitespace-pre-line" style={{ color: "var(--ink)" }}>
            {a.body}
          </p>

          {a.locked && (
            <div className="mt-12 p-10 text-center" style={{ border: "1px solid var(--hairline)", background: "var(--surface)" }}>
              <Lock size={32} style={{ color: "var(--brass)", margin: "0 auto" }} />
              <p className="eyebrow mt-4 mb-2">Reserved for Subscribers</p>
              <h3 className="font-display text-3xl mb-6">Continue reading this piece.</h3>
              <Link to="/subscribe" data-testid="article-locked-cta" className="btn-brass">Become a Member</Link>
            </div>
          )}
        </div>

        <hr className="hairline max-w-3xl mx-auto my-16" />

        <div className="max-w-3xl mx-auto text-center pb-12">
          <p className="text-xs uppercase tracking-[0.22em]" style={{ color: "var(--ink-faint)" }}>
            — Wealth First Editorial
          </p>
        </div>
      </article>
    </div>
  );
}
